import React from "react";

const Footer = () => {
    return (
        <div className="home-footer bg-dark p-4">
            <p className="m-0 text-center" style={{color: 'white', fontWeight: 'bold'}}>&#169; 2023 St Andrews College</p>
        </div>
    );
}

export default Footer;